
import Vue, { PropType } from 'vue'
import { BulkTabletsTransactionRow } from '@/models'
import moment from 'moment'

export default Vue.extend({
  name: 'TabletListItem',

  props: {
    row: Object as PropType<BulkTabletsTransactionRow>,
    no: Number as PropType<number>
  },

  computed: {
    statusTextClass(): string {
      return this.row?.status !== '登録可能' ? 'red' : ''
    },
  }
})
